import React from "react";
import { Button, Table, Text } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import { formatDate, formatMoney } from "../../utils/hotelBookingUtils";
import { BookingRoomRow, HotelBookingTexts } from "./HotelBookingTypes";

type Props = {
    rooms: BookingRoomRow[];
    onRemoveRoom: (id: string) => void;
    t: HotelBookingTexts;
};

export default function RoomBookingTable({ rooms, onRemoveRoom, t }: Props) {
    return (
        <Table withTableBorder striped highlightOnHover>
            <Table.Thead>
                <Table.Tr>
                    <Table.Th>#</Table.Th>
                    <Table.Th>{t.roomType}</Table.Th>
                    <Table.Th>{t.checkIn}</Table.Th>
                    <Table.Th>{t.checkOut}</Table.Th>
                    <Table.Th>{t.guests}</Table.Th>
                    <Table.Th>{t.priceNight}</Table.Th>
                    <Table.Th>{t.nights}</Table.Th>
                    <Table.Th>{t.total}</Table.Th>
                    <Table.Th>{t.actions}</Table.Th>
                </Table.Tr>
            </Table.Thead>

            <Table.Tbody>
                {rooms.length === 0 ? (
                    <Table.Tr>
                        <Table.Td colSpan={9}>
                            <Text c="dimmed" size="sm">{t.noRooms}</Text>
                        </Table.Td>
                    </Table.Tr>
                ) : (
                    rooms.map((row, index) => (
                        <Table.Tr key={row.id}>
                            <Table.Td>{index + 1}</Table.Td>
                            <Table.Td>{row.roomTypeName}</Table.Td>
                            <Table.Td>{formatDate(row.checkInDate.toISOString())}</Table.Td>
                            <Table.Td>{formatDate(row.checkOutDate.toISOString())}</Table.Td>
                            <Table.Td>{row.guestsCount}</Table.Td>
                            <Table.Td>{formatMoney(row.pricePerNight)}</Table.Td>
                            <Table.Td>{row.nights}</Table.Td>
                            <Table.Td>{formatMoney(row.totalPrice)}</Table.Td>
                            <Table.Td>
                                <Button
                                    size="xs"
                                    color="red"
                                    variant="subtle"
                                    onClick={() => onRemoveRoom(row.id)}
                                >
                                    <IconTrash size={15} />
                                </Button>
                            </Table.Td>
                        </Table.Tr>
                    ))
                )}
            </Table.Tbody>
        </Table>
    );
}
